export function parseQuery(queryString: string) {
  const query: { [key: string]: string } = {};
  const pairs = (queryString[0] === '?' ? queryString.substring(1) : queryString).split('&');
  return pairs.reduce((pv, x) => {
    const [key, value] = x.split('=', 2);
    pv[decodeURIComponent(key)] = decodeURIComponent(value || '');
    return pv;
  }, query);
}
